<template>
  <div class="product_price__wrapper">
    <div class="product_price__series" v-if="showError">
      <div class="product_price__series__text">
        {{ getErrorMessage }}
      </div>
    </div>
    <div class="product_price__series" v-else-if="isSeriesPage">
      <div v-if="getIsUserLoggedIn" class="product_price__series__text">
        Please select options
      </div>
      <div v-else-if="getPriceReplaceMessage">
        {{ getPriceReplaceMessage }}
      </div>
      <div v-else class="product_price__not_logged_in__login">
        <legrandav-link label="Sign in" @click="onLoginClick"></legrandav-link>
        <p class="product_price__not_logged_in__login__subtext">
          Sign in to see pricing and lead time.
        </p>
      </div>
    </div>
    <div class="product_price__logged_in" v-else-if="getIsUserLoggedIn">
      <div v-if="getProductStatus && getProductStatus[0].ShowPrice">
        <div
          v-if="!hasPrice && getPriceReplaceMessage"
          class="product_price__logged_in__callForPricing"
        >
          <span>{{ getPriceReplaceMessage }}</span>
        </div>

        <div v-if="!getPriceReplaceMessage">
          <div
            v-if="
              getProductFormattedPrice.includes('Please Call') ||
                (hasPricingLoaded && !hasPrice)
            "
          >
            <div v-if="getProductStatus">
              <div class="email-for-price-link">
                <a
                  tabindex="0"
                  href="mailto:av.pricing@legrand.com"
                  target="_blank"
                >
                  <img
                    src="https://res.cloudinary.com/avd/image/upload/v1643308212/Icons/New%20Design%20Site%20Icons/communication-email_outline_navigation_tab-mob.svg"
                    alt="Email Us"
                  />
                  <span class="email-for-price-link-label">
                    Email for price
                  </span>
                </a>
              </div>
              <p class="product-sku">SKU: {{ getProductSku.SkuCode }}</p>
            </div>
          </div>
          <div
            class="product_price__logged_in__yourprice"
            v-else-if="getProductFormattedPrice"
          >
            Your Price: {{ getProductFormattedPrice }}
            <span class="currency" v-if="hasPrice">{{ getCurrencyCode }}</span>
            <span class="currency" v-html="priceIncrementLable" />
          </div>
        </div>
        <div
          v-if="hasPrice"
          v-bind:class="
            getPriceReplaceMessage
              ? 'product_price__logged_in__row2__hidden'
              : 'product_price__logged_in__row2'
          "
        >
          <div
            class="product_price__logged_in__row2__msrp"
            v-if="getProductFormattedMSRP && !getPriceReplaceMessage"
          >
            <span v-if="hasMSRP">MSRP:</span>
            {{ getProductFormattedMSRP }}
            <span class="currency" v-if="hasMSRP">{{ getCurrencyCode }}</span>
          </div>
          <div v-else-if="getPriceReplaceMessage">
            {{ getPriceReplaceMessage }}
          </div>
          <div class="product_price__logged_in__row2__divider">
            <span />
          </div>
          <div class="product_price__logged_in__row2__sku" v-if="getProductSku">
            SKU: {{ getProductSku.SkuCode }}
          </div>
        </div>
      </div>
    </div>
    <div class="product_price__not_logged_in" v-else-if="getProduct">
      <div class="product_price__not_logged_in__sku" v-if="getProductSku">
        SKU: {{ getProductSku.SkuCode }}
      </div>
      <div
        class="product_price__not_logged_in__divider"
        v-if="getProductSku"
      ></div>
      <div>
        <div v-if="getPriceReplaceMessage">
          {{ getPriceReplaceMessage }}
        </div>
        <div v-else class="product_price__not_logged_in__login">
          <legrandav-link
            label="Sign in"
            @click="onLoginClick"
          ></legrandav-link>
          <p class="product_price__not_logged_in__login__subtext">
            Sign in to see pricing and lead time.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UtilityService from "../../services/UtilityService";
import { mapGetters } from "vuex";

export default {
  props: {
    deviceType: {
      type: String,
      default: " "
    }
  },
  computed: {
    ...mapGetters("product", [
      "getProduct",
      "getProductSku",
      "isSeriesPage",
      "hasMSRP",
      "hasPrice",
      "isLoading",
      "getSelectedOptions",
      "getOptionDefinitions",
      "getCurrencyCode",
      "getProductFormattedPrice",
      "getProductFormattedMSRP",
      "getPriceReplaceMessage",
      "getProductStatus",
      "hasPricingLoaded"
    ]),
    ...mapGetters("user", ["getIsUserLoggedIn"]),
    ...mapGetters("addToCartCount", ["getMinimumOrderUnitOfMeasure"]),
    getErrorMessage() {
      return "Error – Please Call for Assistance";
    },
    showError() {
      return (
        // show an error if
        // 1) there are OptionDefinitions on the series,
        // 2) there are options that we have selected,
        // 3) the number of options that we have selected is greater or equal to the number of total options,
        // 4) there isn't one (and only one) sku selected
        // 5) we are not in a loading state
        this.getOptionDefinitions.length > 0 &&
        this.getSelectedOptions.length > 0 &&
        this.getSelectedOptions.length >= this.getOptionDefinitions.length &&
        this.isSeriesPage &&
        !this.isLoading
      );
    },
    priceIncrementLable() {
      return ` / ${this.getMinimumOrderUnitOfMeasure}`;
    }
  },
  methods: {
    onLoginClick() {
      UtilityService.openSignInMenu();
    },
    callChat() {
      const salesForceChatEvent = new CustomEvent("loadsalesforcechat");
      document.body.dispatchEvent(salesForceChatEvent);
    }
  }
};
</script>

<style lang="scss" scoped>
.product_price {
  font-family: $body;
  letter-spacing: 0.2px;
  color: $darkgray;
  &__wrapper {
    padding-block: 16px;
    border-bottom: 3px solid #a8a8a8;
  }
  &__series {
    &__text {
      font-family: $heading;
      color: $black85;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0;
      @include media-breakpoint-up(lg) {
        font-size: 26px;
      }
    }
  }
  &__logged_in {
    &__yourprice {
      font-family: $heading;
      font-weight: bold;
      font-size: 20px;
      color: $black85;
      @include media-breakpoint-up(lg) {
        font-size: 26px;
      }
      .currency {
        font-size: 16px;
      }
    }
    &__hidden {
      padding-top: 25px;
      font-size: 20px;
      padding-bottom: 12px;
    }
    &__row2 {
      font-family: $body;
      font-size: 14px;
      color: $darkgray;
      min-height: 24px;
      display: flex;
      padding-top: 14px;
      border-top: 0.5px #ffffff;
      @include media-breakpoint-up(lg) {
        padding-top: 12px;
      }
      @include media-breakpoint-up(sm) {
        font-size: 16px;
      }
      &__msrp {
        .currency {
          font-size: 12px;
        }
        @include media-breakpoint-up(lg) {
          font-size: 16px;
        }
      }
      &__hidden {
        min-height: 24px;
        display: flex;
      }
      &__divider {
        margin: 0 auto;
        span {
          border-right: 1px solid #a8a8a8;
          height: 100%;
          display: block;
        }
      }
      &__sku {
        text-align: right;
        @include media-breakpoint-up(lg) {
          font-size: 16px;
        }
      }
    }
    &__callForPricing {
      font-size: 18px;
      margin-bottom: 25px;

      @include media-breakpoint-up(sm) {
        font-size: 20px;
      }
      @include media-breakpoint-up(lg) {
        font-size: 24px;
      }
    }
  }
  &__not_logged_in {
    min-height: 24px;
    display: flex;
    flex-direction: column;
    &__login {
      font-family: $body;
      font-size: 20px !important;
      margin-top: 16px;
      a {
        color: $primary;
        text-decoration: underline;
        cursor: pointer;
      }
      @include media-breakpoint-up(md) {
        margin-top: 16px;
      }
      @include media-breakpoint-up(lg) {
        font-size: 26px;
      }
      &__subtext {
        color: $darkgray;
        font-size: 16px;
        letter-spacing: 0.2px;
        margin: 8px 0 0 0;
      }
    }
    &__divider {
      border-bottom: 3px solid #a8a8a8;
    }
    &__sku {
      font-family: $body;
      color: $darkgray;
      font-size: 14px;
      letter-spacing: 0.4px;
      margin-bottom: 14px;
      @include media-breakpoint-up(lg) {
        font-size: 16px;
        letter-spacing: 0.2px;
        margin-bottom: 16px;
      }
    }
  }
  &__unavailable {
    font-size: 20px;
  }
}
.email-for-price-link {
  display: flex;
  color: rgb(46, 82, 118);
  letter-spacing: 0px;

  a {
    font-family: $heading;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 26px;
    font-weight: bold;
    color: $primary;

    @media screen and (max-width: $media-max-width-desktop) {
      font-size: 20px;
    }

    img {
      height: auto;
      width: 34px;
      padding-top: 2px;
      padding-right: 10px;

      @media screen and (max-width: $media-max-width-desktop) {
        width: 28px;
      }
    }

    &:hover {
      color: $primary-300;

      img {
        opacity: 0.7;
      }
    }

    &:focus {
      color: $primary-300;

      img {
        opacity: 0.5;
      }
    }
  }
}

.product-sku {
  color: $darkgray;
  font-family: $body;
  font-size: 16px;
  letter-spacing: 0.2px;
  margin-top: 10px;
  margin-bottom: 0;

  @media screen and (max-width: $media-max-width-desktop) {
    font-size: 14px;
  }
}
</style>
